import { EventorTriggers } from './modules/EventorTriggers';
export class Eventor {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    trigger = new EventorTriggers(this);
}
